import { usePreviewPanelsActions, usePreviewPanelsContext } from '@atlassian/preview-panels-api';

import { useCloseAllOpenSidePanels } from './useCloseAllOpenSidePanels';

export const useClosePreviewPanel = () => {
	const context = usePreviewPanelsContext();
	const { close } = usePreviewPanelsActions();
	const { closeAllOpenSidePanels } = useCloseAllOpenSidePanels();

	/*
	NOTE PLEASE READ:
	closeOnlyPreviewPanel() will only be used for closing any open preview panel when
	the confluence content wrapper panels (aka object sidebar) are opened. Outside of this scenario
	this function SHOULD NOT BE USED for closing preview panels. Once content wrapper
	panels are migrated to preview panels, this function will be deprecated.
	*/
	const closeOnlyPreviewPanel = (onClose?: () => void): void => {
		if (context?.state?.panel) {
			close(onClose);
		}
	};

	const closeAllPanels = (onClose?: () => void): void => {
		closeOnlyPreviewPanel(onClose);
		closeAllOpenSidePanels();
	};

	return { closeAllPanels, closeOnlyPreviewPanel };
};
